import { ClockCounterClockwiseIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import {
  SearchResultButton,
  SearchResultList,
} from "@/components/SearchResultList/SearchResultList";
import { usePreviousAirportSearches } from "@/hooks/usePreviousSearches";
import type { FlightFormLocation } from "@/types/types";

import { LocationName } from "./LocationName";

type Props = {
  previousSearches: FlightFormLocation[];
  onClick: (location: FlightFormLocation) => void;
};

export function LastSearchedAirportList({ onClick, previousSearches }: Props) {
  const intl = useIntl();
  const { removePreviousSearch } = usePreviousAirportSearches();

  return (
    <SearchResultList
      heading={intl.formatMessage({ id: "flights.search.lastSearched" })}
      data={previousSearches}
      getItemKey={(location) => location.id}
      renderItem={(location) => {
        return (
          <SearchResultButton
            key={location.id}
            icon={ClockCounterClockwiseIcon}
            primaryText={<LocationName location={location} />}
            code={location.code}
            onClick={() => onClick(location)}
            onRemove={() => removePreviousSearch(location.id)}
            secondaryText={
              location.type === "AIRPORT"
                ? `${location.cityName}, ${location.countryName}`
                : location.countryName
            }
          />
        );
      }}
    />
  );
}
